import { gatherLights } from '../render/night/nightLights';
import type { Runtime } from './runtime';
import type { World } from '../world/types';

export function createCityLights(world: World, runtime: () => Runtime) {
  return gatherLights([
    ...world.animated.flatMap((animation) => (animation.lights ? [animation.lights] : [])),
    { moving: true, list: () => runtime().visitorView.lights.list() },
    { moving: true, list: () => runtime().network?.lights.list() ?? [] },
  ]);
}
